<div class="template1 site">
        <app-header [class.d-none]="isPromotionContent"></app-header>
        <div [ngClass]="{'content-part site-content':!isPromotionContent}" class="">
            <router-outlet></router-outlet>
        </div>
        <app-footer class="site-footer" [class.d-none]="isPromotionContent" [placeHolderId]="'footer'" [customerType]="'flpi'"></app-footer>
    </div>